const { default: IllustratorFormPage } = require("./IllustratorFormPage")

const IllustratorCreate = () => {
  return (
    <IllustratorFormPage></IllustratorFormPage>
  )
}

export default IllustratorCreate